import React from "react";
import { VintomError } from "src/api/model/error/VintomError";
import { I18n } from "../../../../i18n/i18n";
import { Subtitle } from "../../../../model/playerConfiguration/Subtitle";
import { MobileOverlayState } from "../../../../uiModel/mobileOverlay/MobileOverlayState";
import { SocialShareConfiguration } from "../../../../uiModel/socialShare/SocialShareConfiguration";
import { LoaderIconComponent } from "../../../icons/loader/LoaderIconComponent";
import { PauseIconComponent } from "../../../icons/playback/PauseIconComponent";
import { PlayIconComponent } from "../../../icons/playback/PlayIconComponent";
import { ReplayIconComponent } from "../../../icons/playback/ReplayIconComponent";
import { VolumeMutedIconComponent } from "../../../icons/volume/VolumeMutedIconComponent";
import { MessageComponent } from "../common/MessageComponent";
import { SocialShareComponent } from "../common/SocialShareComponent";
import { SubtitleSelectorComponent } from "../common/SubtitleSelectorComponent";

import "@styles/c-mobileOverlay.scss";

interface Props {
  i18n: I18n;
  controlState?: MobileOverlayState;
  onUnmute: () => void;
  subtitles: Subtitle[];
  selectedSubtitlesSrc?: string;
  onSubtitleSourceSelected: (subtitle?: Subtitle) => void;
  socialShareConfiguration: SocialShareConfiguration;
  onShared: () => void;
  message: string | VintomError;
  onSendError: (error: VintomError) => void;
  playIconOnPoster: boolean;
  disableIcon: boolean;
}

export const MobileOverlayComponent: React.SFC<Props> = (props) => {
  const {
    i18n,
    controlState,
    onUnmute,
    subtitles,
    selectedSubtitlesSrc,
    onSubtitleSourceSelected,
    socialShareConfiguration,
    onShared,
    message,
    onSendError,
    playIconOnPoster,
    disableIcon
  } = props;

  if (!controlState) {
    return <></>;
  }

  let control: React.ReactNode;
  switch (controlState) {
    case "message":
      control = <MessageComponent
        i18n={i18n}
        message={message}
        onSendError={onSendError}
      />;
      break;
    case "loading":
      control = <div className="c-mobileOverlay__loader">
        <LoaderIconComponent />
      </div>;
      break;
    case "socialSelector":
      if (socialShareConfiguration.canShare) {
        control = <div
          className="c-mobileOverlay__control"
        >
          <SocialShareComponent
            i18n={i18n}
            facebookShareUrl={socialShareConfiguration.facebookUrl}
            twitterShareUrl={socialShareConfiguration.twitterUrl}
            onShared={onShared}
          />
        </div>;
      } else {
        control = <></>;
      }
      break;
    case "subtitlesSelector":
      control = <div
        className="c-mobileOverlay__control"
      >
        <SubtitleSelectorComponent
          i18n={i18n}
          subtitles={subtitles}
          selectedSubtitlesSrc={selectedSubtitlesSrc}
          onSubtitleSourceSelected={onSubtitleSourceSelected}
        />
      </div>;
      break;
    case "unmute":
      control = <div
        className={`c-mobileOverlay__button c-mobileOverlay__button--active`}
        onClick={onUnmute}
      >
        <VolumeMutedIconComponent />
      </div>;
      break;
    case "pause":
      if (playIconOnPoster === true && disableIcon) {
        return <></>;
      } else {
        control = <div className="c-mobileOverlay__button">
        <PlayIconComponent />
      </div>;
      }
      break;
    case "play":
      control = <div className="c-mobileOverlay__button">
        <PauseIconComponent />
      </div>;
      break;

    case "replay":
      control = <div className="c-mobileOverlay__button">
        <ReplayIconComponent />
      </div>;
      break;
    default:
      control = <></>;
      break;
  }

  return (
    <div className="c-mobileOverlay">
      {control}
    </div>
  );
};
